@use '@/styles/tokens' as *;
@use '@/styles/mixins' as *;

// Figma 1422:611335: two tiles in a centred row, 40px apart.
.tiles {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--space-10);
}

.tile {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px; // Figma 1422:611335 — no token between 16 and 20
  min-width: 0;
  text-align: center;
  text-decoration: none;
}

// Figma 1422:611335: an 85.25px square (39px glyph + 23.25px padding), 23.25px radius — no
// matching tokens.
.icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 23.25px;
  border-radius: 23.25px;
  background: $color-light-green-400;
  color: var(--text-primary); // Figma `stone` #343330 has no token; nearest text token
}

.label {
  font-family: $font-family-base;
  font-size: $font-size-14;
  font-weight: $font-weight-regular;
  line-height: 1;
  color: var(--text-primary);
  overflow-wrap: anywhere;
}

// AC: both contacts are link-styled; the unavailable "-" stays plain text.
.link {
  border-radius: var(--radius-md);

  @include focus-ring;

  .label {
    color: $color-info-700;
  }

  &:hover .label,
  &:focus-visible .label {
    text-decoration: underline;
  }
}

.srOnly {
  @include visually-hidden;
}
